import { camelToSnakeCase } from "go-component/utils/componentUtils";
import { FilterValue } from "../services/types";

export const convertFilterValuesToSnakeCase = (filterValues: FilterValue[]) => {
	return filterValues.map((filterValue) => {
		const { field_name } = filterValue;
		const newFieldName = camelToSnakeCase(field_name).toLowerCase();
		return { ...filterValue, field_name: newFieldName };
	});
};
